var React = require('react');

function Repeat (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M20 12C20 7.58172 16.4183 4 12 4C7.58172 4 4 7.58172 4 12C4 16.4183 7.58172 20 12 20C12.2761 20 12.5 19.7761 12.5 19.5C12.5 19.2239 12.2761 19 12 19C8.13401 19 5 15.866 5 12C5 8.13401 8.13401 5 12 5C15.866 5 19 8.13401 19 12C19 12.6958 18.8985 13.3679 18.7094 14.0023L16.0607 11.3536C15.8654 11.1583 15.5488 11.1583 15.3536 11.3536C15.1583 11.5488 15.1583 11.8654 15.3536 12.0607L18.8891 15.5962C19.0599 15.767 19.3237 15.7884 19.5178 15.6603C19.5455 15.642 19.5718 15.6206 19.5962 15.5962L23.1317 12.0607C23.327 11.8654 23.327 11.5488 23.1317 11.3536C22.9365 11.1583 22.6199 11.1583 22.4246 11.3536L19.7373 14.0408C19.9087 13.3893 20 12.7053 20 12Z"}));
}

Repeat.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Repeat;

Repeat.default = Repeat;
